// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsSample2-Sample2View-Sample2View-module__box--XSJ1w {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 24px;
}
.src-businessServices-services-bsSample2-Sample2View-Sample2View-module__topLine--NWke_ {
  display: flex;
  max-width: 1800px;
  gap: 24px;
}
.src-businessServices-services-bsSample2-Sample2View-Sample2View-module__topLine--NWke_ .src-businessServices-services-bsSample2-Sample2View-Sample2View-module__item--q0DOw {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.src-businessServices-services-bsSample2-Sample2View-Sample2View-module__topLine--NWke_ .src-businessServices-services-bsSample2-Sample2View-Sample2View-module__item--q0DOw div:first-child {
  color: rgba(0, 0, 0, 0.55);
}
.src-businessServices-services-bsSample2-Sample2View-Sample2View-module__topLine--NWke_ .src-businessServices-services-bsSample2-Sample2View-Sample2View-module__item--q0DOw div:last-child {
  display: flex;
  padding: 5px 12px;
  align-items: center;
  border-radius: 4px;
  border: thin solid #d9d9d9;
  background: #f5f5f5;
  color: rgba(0, 0, 0, 0.3);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.src-businessServices-services-bsSample2-Sample2View-Sample2View-module__line2--deQ2V {
  display: flex;
}
.src-businessServices-services-bsSample2-Sample2View-Sample2View-module__line2--deQ2V .src-businessServices-services-bsSample2-Sample2View-Sample2View-module__labelBox--HB1Mn {
  flex: 1;
}
.src-businessServices-services-bsSample2-Sample2View-Sample2View-module__line2--deQ2V .src-businessServices-services-bsSample2-Sample2View-Sample2View-module__labelBox--HB1Mn label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.src-businessServices-services-bsSample2-Sample2View-Sample2View-module__mainLine--hQSmY {
  flex: 1;
  display: flex;
  overflow: hidden;
}
.src-businessServices-services-bsSample2-Sample2View-Sample2View-module__imgBox--erBJz {
  height: 100%;
  overflow: hidden;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-left: thin solid silver;
  border-top: thin solid silver;
}
.src-businessServices-services-bsSample2-Sample2View-Sample2View-module__imgBox--erBJz .src-businessServices-services-bsSample2-Sample2View-Sample2View-module__img--IrRZP {
  border: thin solid silver;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsSample2/Sample2View/Sample2View.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;AACF;AAEA;EACE,aAAA;EACA,iBAAA;EACA,SAAA;AAAF;AAHA;EAMI,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAAJ;AATA;EAYM,0BAAA;AAAN;AAZA;EAeM,aAAA;EACA,iBAAA;EACA,mBAAA;EAEA,kBAAA;EACA,0BAAA;EACA,mBAAA;EAEA,yBAAA;EAEA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAHN;AAQA;EACE,aAAA;AANF;AAKA;EAGI,OAAA;AALJ;AAEA;EAKM,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAJN;AASA;EACE,OAAA;EACA,aAAA;EACA,gBAAA;AAPF;AAUA;EACE,YAAA;EACA,gBAAA;EACA,YAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;EACA,6BAAA;AATF;AAAA;EAYI,yBAAA;AATJ","sourcesContent":[".box {\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 0 24px;\n}\n\n.topLine {\n  display: flex;\n  max-width: 1800px;\n  gap: 24px;\n\n  .item {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n\n    div:first-child {\n      color: rgba(0, 0, 0, 0.55);\n    }\n    div:last-child {\n      display: flex;\n      padding: 5px 12px;\n      align-items: center;\n\n      border-radius: 4px;\n      border: thin solid #d9d9d9;\n      background: #f5f5f5;\n\n      color: rgba(0, 0, 0, 0.3);\n\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n}\n\n.line2 {\n  display: flex;\n  .labelBox {\n    flex: 1;\n    label {\n      display: inline-flex;\n      align-items: center;\n      gap: 8px;\n      cursor: pointer;\n    }\n  }\n}\n\n.mainLine {\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n}\n\n.imgBox {\n  height: 100%;\n  overflow: hidden;\n  padding: 8px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-left: thin solid silver;\n  border-top: thin solid silver;\n\n  .img {\n    border: thin solid silver;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-businessServices-services-bsSample2-Sample2View-Sample2View-module__box--XSJ1w`,
	"topLine": `src-businessServices-services-bsSample2-Sample2View-Sample2View-module__topLine--NWke_`,
	"item": `src-businessServices-services-bsSample2-Sample2View-Sample2View-module__item--q0DOw`,
	"line2": `src-businessServices-services-bsSample2-Sample2View-Sample2View-module__line2--deQ2V`,
	"labelBox": `src-businessServices-services-bsSample2-Sample2View-Sample2View-module__labelBox--HB1Mn`,
	"mainLine": `src-businessServices-services-bsSample2-Sample2View-Sample2View-module__mainLine--hQSmY`,
	"imgBox": `src-businessServices-services-bsSample2-Sample2View-Sample2View-module__imgBox--erBJz`,
	"img": `src-businessServices-services-bsSample2-Sample2View-Sample2View-module__img--IrRZP`
};
export default ___CSS_LOADER_EXPORT___;
